import(/* webpackMode: "eager" */ "C:\\Users\\manito\\Documents\\ระบบทวนสอบ\\app\\src\\app\\(dashboard)\\dashboard\\page.tsx");
